import { render, staticRenderFns } from "./OrdineLavorazioni.vue?vue&type=template&id=483fe46f"
import script from "./OrdineLavorazioni.vue?vue&type=script&lang=js"
export * from "./OrdineLavorazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports